<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container main_bg">
      <i-card-vertical headerTitle="고객관리" device="web" :IsUseEditorBox="true">
        <template v-slot:EditorBox>
          <v-row no-gutters>
            <v-col class="d-flex justify-space-between align-center">
              <v-switch v-model="delYn">
                <template v-slot:label>
                  <span style="margin-left: 5px;">{{ delYn ? '사용' : '미사용' }}</span>
                </template>
              </v-switch>
            </v-col>
          </v-row>
        </template>

        <template v-slot:body>
          <DxDataGrid
            id="clientDataGrid"
            class="layout-col-height00"
            :ref="dxDataGridRef"
            :data-source="gridMain"
            :remote-operations="false"
            :hover-state-enabled="true"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            :row-alternation-enabled="true"
            :column-auto-width="true"
            :show-borders="true"
            :show-row-lines="true"
            :selection="{ mode: 'single' }"
            key-expr="rgstNo"
            :focused-row-enabled="true"
            @row-updating="onRowUpdating"
            @editing-start="onEditingStart"
            @editor-preparing="onEditorPreparing"
          >
            <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />

            <DxSelection select-all-mode="allPages" show-check-boxes-mode="always" mode="multiple" />

            <DxColumn data-field="clntId" data-type="string" :visible="false"></DxColumn>
            <DxColumn data-field="clntIdLeader" data-type="string" :visible="false"></DxColumn>

            <DxColumn
              data-field="save"
              data-type="string"
              width="100px"
              alignment="center"
              caption
              :allow-editing="false"
              cell-template="actionTemplete"
            ></DxColumn>
            <template #actionTemplete="{ data: cellInfo }">
              <div>
                <v-btn color="primary" elevation="0" dark small @click="btnDetail(cellInfo)" class="rounded px-3 grid-btn">상세보기</v-btn>
              </div>
            </template>

            <DxColumn
              data-field="clntNmLeader"
              data-type="string"
              width="150px"
              caption="대표법인"
              alignment="left"
              edit-cell-template="selectEditorLeader"
            />

            <template #selectEditorLeader="{ data: cellInfo }">
              <v-autocomplete
                :value="cellInfo.data.clntIdLeader + '_' + cellInfo.data.clntId"
                class="ml-8 appbar-autocomplete"
                item-text="clntNmLeader"
                item-value="key"
                :menu-props="{ offsetY: true }"
                :items="clntList"
                placeholder="대표법인 선택"
                height="30"
                width="100%"
                flat
                solo
                style="background: #fff;"
                :filter="filterCompanyGroup"
                @input="value => clntLeaderChanged(value, cellInfo)"
              >
                <template v-slot:prepend-item>
                  <v-divider></v-divider>
                  <v-list-item class="company-group-item">
                    <v-list-item-content>
                      <div class="company-group-grid header">
                        <span>고객사명</span>
                        <span>대표자</span>
                        <span>주소</span>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                </template>

                <template v-slot:item="{ item, attrs, on }">
                  <v-list-item v-bind="attrs" v-on="on" dense class="company-group-item">
                    <v-list-item-content>
                      <div class="company-group-grid">
                        <span class="ellipsis">{{ item.clntNm }}</span>
                        <span class="ellipsis">{{ item.rpstNm }}</span>
                        <span class="ellipsis">{{ item.addrs1 }}</span>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </template>
            <DxColumn data-field="clntNm" data-type="string" width="150px" caption="고객사명" alignment="left" :allow-editing="false" />

            <DxColumn
              data-field="rgstNo"
              data-type="string"
              width="150px"
              alignment="center"
              caption="사업자등록번호"
              :allow-editing="false"
            ></DxColumn>

            <DxColumn data-field="rpstNm" data-type="string" width="100px" alignment="center" caption="대표자명" :allow-editing="false" />

            <DxColumn data-field="telNo" data-type="string" alignment="center" caption="전화번호" :allow-editing="false"></DxColumn>

            <DxColumn data-field="addrs" data-type="string" width="460px" alignment="left" caption="주소" :allow-editing="false" />

            <DxColumn data-field="joinNm" caption="가입구분" width="110px" data-type="string" alignment="center" edit-cell-template="selectEditor" />
            <template #selectEditor="{ data: cellInfo }">
              <v-autocomplete
                :items="joinList"
                :value="cellInfo.value"
                item-text="minorNm"
                dense
                solo
                hide-details
                @input="value => onJoinListChanged(value, cellInfo)"
              ></v-autocomplete>
            </template>

            <DxColumn data-field="joinDt" data-type="string" alignment="center" caption="가입일" :allow-editing="false"></DxColumn>

            <DxColumn data-field="useYn" data-type="boolean" caption="사용" alignment="center" width="90px" edit-cell-template="checkBoxEditor" />

            <template #checkBoxEditor="{ data: cellInfo }">
              <DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :onValueChanged="value => onCheckValueChanged(value, cellInfo)" />
            </template>
          </DxDataGrid>
        </template>
      </i-card-vertical>

      <i-card-right headerTitle :useBtnList="buttonUseList" @btnSearch="btnSearch(true)" @btnSave="btnSave()"></i-card-right>
    </v-sheet>
  </v-container>
</template>
<script>
import { getClientManage, saveClientManage } from '@/api/adminManagement/clientManage'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import baseview from '@/views/base/baseview.vue'
import { getClientList } from '@/api/setting/clientManage'
export default {
  mixins: [baseview, BaseDataGrid],
  name: 'ClientManage',
  data() {
    return {
      pageSizes: [5],
      showPageSizeSelector: false,
      dxDataGridRef: 'clientDataGrid',
      gridMain: [],
      buttonUseList: [
        'btnSearch', //조회
        'btnSave' //저장
      ],
      delYn: true,
      delYnList: [
        { text: '사용', value: true },
        { text: '미사용', value: false }
      ],
      joinList: [],
      showSearchPanel: false,
      companyGroupSearch: '',
      clntList: []
    }
  },
  activated() {
    if (this.$route.params?.delYn === undefined) this.delYn = true
    else {
      this.delYn = this.$route.params?.delYn
    }

    if (this.$route.params.data) {
      let params = this.$route.params.data
      if (params.flag) {
        this.btnSearch(true)
      }
    }
  },
  computed: {},
  watch: {
    delYn() {
      this.btnSearch(true)
    }
  },
  beforeMount() {},
  mounted() {
    this.btnSearch(true)
  },
  methods: {
    btnFilter() {
      this.showSearchPanel = !this.showSearchPanel
      console.log('btnFilter!!!')
    },
    //------------------------------------------
    //  고객 조회
    //------------------------------------------
    async btnSearch(flag) {
      this.openLoading('searching')
      // this.clients = []

      let params = {
        useYn: this.delYn ? 'Y' : 'N'
      }

      try {
        const response = await getClientManage(params, flag)
        await getClientList({ validOnly: true }).then(res => {
          this.clntList = res.list
        })
        this.joinList = response.commonCodeData.map(item => {
          item.disabled = item.useYn == 'N'
          return item
        })
        this.gridInit(this.GetDataGrid(this.dxDataGridRef))
        this.gridMain = []
        this.gridMain = response.clientInfoData
        this.gridMain = response.clientInfoData.map(item => {
          item.addrs = `(${item.zipCd}) ${item.addrs1} ${item.addrs2}`
          return item
        })
        this.gridMain = response.clientInfoData.map(item => {
          item.joinDt = `${item.joinDt.slice(0, 4)}.${item.joinDt.slice(4, 6)}.${item.joinDt.slice(6, 8)}`
          return item
        })
        this.FocusFirstRow(this.GetDataGrid(this.dxDataGridRef))
      } catch (error) {
        console.error('getClientManage error catch >> ', error)
      } finally {
        this.endLoading()
      }
    },
    //------------------------------------------
    //  고객 저장
    //------------------------------------------
    btnSave() {
      this.GetDataGrid(this.dxDataGridRef)
        .getSelectedRowsData()
        .then(selectedRows => {
          if (selectedRows.length === 0) {
            this.vToastify(this.$t('selectionData'), 'info')
            return
          }
          console.log('#### selectedRows', selectedRows)
          this.vToastifyPrompt(
            this.$t('doSaveData'),
            'info',
            async () => {
              this.GetDataGrid(this.dxDataGridRef).beginUpdate()
              this.GetDataGrid(this.dxDataGridRef).saveEditData()
              this.openLoading('saving')
              selectedRows.forEach(items => {
                const match = this.joinList.find(join => join.minorNm === items.joinNm)
                if (match) {
                  this.$set(items, 'joinDiv', match.minorCd) // Using Vue.set to ensure reactivity
                }
              })

              try {
                const response = await saveClientManage(selectedRows, true)
                if (response.success) {
                  this.GetDataGrid(this.dxDataGridRef).endUpdate()
                  this.btnSearch(false)
                }
              } catch (error) {
                console.error('saveClientManage error catch >> ', error)
              } finally {
                this.endLoading()
              }
            },
            null,
            true
          )
        })
    },
    //------------------------------------------
    //  고객 상세 페이지 이동
    //------------------------------------------
    async btnDetail(cellInfo) {
      const toRouter = {
        name: 'ClientManageDetail',
        params: {
          data: cellInfo.data
        }
      }
      this.$router.push(toRouter)
    },
    ///////////////////////////////////////
    /*           DataGrid Event          */
    ///////////////////////////////////////
    onEditingStart(e) {},
    onJoinListChanged(value, cellInfo) {
      cellInfo.setValue(value)
      cellInfo.component.updateDimensions()
      const dataGrid = this.GetDataGrid(this.dxDataGridRef)
      const rowIndex = dataGrid.getRowIndexByKey(cellInfo.key)
      if (rowIndex >= 0) {
        dataGrid.focus(dataGrid.getCellElement(rowIndex, 0))
        dataGrid.selectRows([cellInfo.key], true)
      }
    },
    clntLeaderChanged(value, cellInfo) {
      if (!value || !cellInfo) {
        return
      }
      cellInfo.setValue(value.clntNm)
      const dataGrid = this.GetDataGrid(this.dxDataGridRef)
      const rowIndex = dataGrid.getRowIndexByKey(cellInfo.key)
      if (rowIndex >= 0) {
        dataGrid.cellValue(rowIndex, 'clntIdLeader', value.clntId)
        cellInfo.data.clntIdLeader = value.clntId
        dataGrid.focus(dataGrid.getCellElement(rowIndex, 0))
        dataGrid.selectRows([cellInfo.key], true)
      }
      cellInfo.component.updateDimensions()
    },
    filterCompanyGroup(item, queryText, itemText) {
      const search = (queryText || '')
        .toString()
        .trim()
        .toLowerCase()
      if (!search) {
        return true
      }

      const targets = [item.compNm, item.clntNm, item.addrs1]
      return targets.some(field =>
        (field || '')
          .toString()
          .toLowerCase()
          .includes(search)
      )
    }
  }
}
</script>

<style lang="scss">
.dx-command-select {
  width: 30px !important;
  min-width: 30px !important;
}
.dropzone-external {
  width: 65px;
  height: 30px;
  background-color: rgba(183, 183, 183, 0.1);
  border-width: 0px;
  padding: 0px;
}

.widget-container > span {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 16px;
}

.dropzone-image {
  max-width: 100%;
  max-height: 100%;
}

.flex-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: left;
}

.widget-container {
  margin-right: 320px;
}

.contents h4 {
  margin-bottom: 10px;
  font-weight: 500;
  font-size: 18px;
}

.contents {
  margin-top: 50px;
  margin-left: 10px;
  display: none;
}

.fileList {
  padding: 10px;
  width: 400px;
  background-color: rgba(183, 183, 183, 0.1);
}

.fileNm {
  height: 20px;
  font-weight: bold;
}

.fileList > .fileSize {
  height: 20px;
  font-size: 12px;
}
.v-select--chips > .v-input__control > .v-input__slot > .v-select__slot > .v-select__selections {
  overflow: scroll;
  flex-wrap: nowrap;
}
.v-chip {
  overflow: initial;
}
.company-group-item {
  padding-left: 16px;
  padding-right: 16px;
  border-bottom: 1px solid #e0e0e0;
}

.company-group-grid {
  display: grid;
  grid-template-columns: 1.4fr 1fr 1.6fr;
  gap: 8px;
  align-items: center;
}

.company-group-grid.header {
  font-size: 15px;
  font-weight: 600;
  color: #1976d2;
}

.company-group-grid .ellipsis {
  font-size: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
